import { render } from "./brantFare.vue?vue&type=template&id=69954085&scoped=true"
import script from "./brantFare.vue?vue&type=script&lang=js"
export * from "./brantFare.vue?vue&type=script&lang=js"

import "./brantFare.vue?vue&type=style&index=0&id=69954085&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69954085"]])

export default __exports__